import request from "@/libs/request";
import {
  CreateReagentAltRequest,
  CreateReagentAltResponse,
  DeleteReagentAltRequest,
  DeleteReagentAltResponse,
  ReadReagentAltResponse,
  UpdateReagentAltRequest,
  UpdateReagentAltResponse,
} from "@/types/reagent-alt";

// 대체품 목록 조회 (전체 - 페이지네이션 없음)
export const readReagentAlt = async (): Promise<ReadReagentAltResponse> => {
  const response = await request.post<ReadReagentAltResponse>(
    `/reagent-alt/read`,
    {}
  );
  return response.data;
};

// 대체품 자사품 추가
export const createReagentAlt = async (
  data: CreateReagentAltRequest
): Promise<CreateReagentAltResponse> => {
  const response = await request.post<CreateReagentAltResponse>(
    `/reagent-alt/create`,
    data
  );
  return response.data;
};

// 대체품 수정
export const updateReagentAlt = async (
  data: UpdateReagentAltRequest
): Promise<UpdateReagentAltResponse> => {
  const response = await request.post<UpdateReagentAltResponse>(
    `/reagent-alt/update`,
    data
  );
  return response.data;
};

// 대체품 삭제
export const deleteReagentAlt = async (
  data: DeleteReagentAltRequest
): Promise<DeleteReagentAltResponse> => {
  const response = await request.post<DeleteReagentAltResponse>(
    `/reagent-alt/delete`,
    data
  );
  return response.data;
};
